import React from 'react';
import { default as Highlighter } from 'react-highlight-words';
import { Tooltip } from '@cimpress/react-components';
import { JustifyContent, FlexBox } from '../../../utils/css-classes';

// tslint:disable-next-line:import-name
import style from './index.module.css';

export interface TileProps {
  title: string;
  topRightLabelText?: string;
  onClick?: () => void;
  iconClassName: string;
  paddingClass?: string;
  bottomRightIconClassName?: string;
  bottomRightIconTitle?: string;
  highlight?: string;
}

// tslint:disable-next-line: variable-name
const TileComponent = ({
  title,
  topRightLabelText,
  onClick,
  iconClassName,
  paddingClass,
  bottomRightIconClassName,
  bottomRightIconTitle,
  highlight,
}: TileProps) => {
  const tile = (
    <div className={`${style.TileComponent} mx-4 ${paddingClass || 'py-4'} text-center`}>
      <div className={`${FlexBox.FLEX} ${JustifyContent.CENTER}`}>
        <span className={`m-2 ${iconClassName}`} />
        {topRightLabelText && <small style={{ fontWeight: 'bold' }}>{topRightLabelText}</small>}
        {bottomRightIconClassName &&
          bottomRightIconTitle
            ? <Tooltip direction="right" contents={bottomRightIconTitle}>
              <i className={`fas ${bottomRightIconClassName}`}></i>
            </Tooltip>
            : <i className={`fas ${bottomRightIconClassName}`}></i>}
      </div>
      <small className={style.Title}>
        <Highlighter
          highlightClassName="highlight"
          searchWords={highlight ? [highlight] : []}
          autoEscape={true}
          textToHighlight={title}
        />
      </small>
    </div>
  );

  return onClick ?
    (
      <a
        className="clickable"
        title={title}
        onClick={() => onClick()}
      >
        {tile}
      </a>
    ) :
    tile;
};

export default TileComponent;
